module.exports = __webpack_public_path__ + "static/media/Nikasi.b67d985f.gif";